import React, { useState, useEffect, useCallback } from "react";
import { Carousel } from "react-bootstrap";
import Swal from "sweetalert2";
import { Cart, Phone } from "iconoir-react";
import "./carouselcomp.css";
import { trackBannerClick, trackFormSubmit } from "../../../utils/gtm";

import { domain } from "../../Urls/Services/Api_urls";

const Carouselcomp = () => {
 
  const [Imgs, setImg] = useState([]);

  let nextId = 0;

  /* The `getData` function is a callback function that is used to fetch data from the server and
  update the state variables `data` and `Imgs`. */
  const getData = useCallback(async () => {
    try {
      const response = await fetch(domain + "/images/banner/", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
    
  

      const imgs = data.map((item) => {
        const banner =
          window.innerWidth < 540 ? item.banner_responsive : item.banner;
        return {
          id: nextId++,
          banner: domain + banner,
        };
      });
      setImg(imgs);
    } catch (error) {
      console.log(error);
    }
  }, [nextId]);

  useEffect(() => {
    getData();
  }, [getData]);

  /* The `handleButtonClick` function is a callback function that is triggered when a button is
  clicked. It opens a Swal (SweetAlert) modal with a form for the user to fill out. The form
  includes input fields for name, last name, phone, email, select options for city, and input fields
  for neighborhood and address. */
  const handleButtonClick = useCallback(() => {
    Swal.fire({
      title: "Solicitud de servicio",
      html: `
        <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Nombre *</label>
        <input id="nombre" class="swal2-input" placeholder="Nombre *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
        <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Apellido *</label>
        <input id="apellido" class="swal2-input" placeholder="Apellido *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
        <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Telefono *</label>
        <input id="telefono" class="swal2-input" placeholder="Telefono *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
        <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Correo electronico *</label>
        <input id="mail" type="email" class="swal2-input" placeholder="Correo electronico *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
        <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Dirección *</label>
        <input id="direccion" class="swal2-input" placeholder="Dirección *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
        <h6 style="width: 70%; margin: 0 auto 0.5rem; text-align: left; font-weight: 400;">Dirección + torre y/o apartamento + Unidad</h6>
        <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Barrio *</label>
        <input id="neighborhood" class="swal2-input" placeholder="Barrio" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
        <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Ciudad *</label>
        <select class="select swal2-input" id="mySelectElement" style="width: 70%; height: 3.4rem; margin: 0.3rem auto 1rem; border: 1px solid;">
          <option value="Cali">Cali</option>
          <option value="Jamundi">Jamundi</option>
          <option value="Yumbo">Yumbo</option>
          <option value="Candelaria">Candelaria</option>
          <option value="Puerto tejaada">Puerto tejaada</option>
          <option value="Palmira">Palmira</option>
        </select>
      `,
      confirmButtonColor: "#4a1272",
      confirmButtonText: "Enviar",
      showCloseButton: true,
      focusConfirm: false,
      preConfirm: () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          name: document.getElementById("nombre").value,
          last_name: document.getElementById("apellido").value,
          phone: document.getElementById("telefono").value,
          address: document.getElementById("direccion").value,
          mail: document.getElementById("mail").value,
          neighborhood: document.getElementById("neighborhood").value,
          city: document.getElementById("mySelectElement").value,
          service: "Solicitud realizada desde el banner principal",
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        return fetch(domain + "/portal/out/", requestOptions)
        .then((response) => {
          // Intenta convertir la respuesta en JSON
          return response.json().then((data) => {
            if (!response.ok) {
              // Si la respuesta no es OK, lanza un error con el mensaje devuelto
              const errorMsg = data.msg || response.statusText;
              throw new Error(errorMsg);
            }
            // Si todo va bien, muestra el mensaje de éxito
            trackFormSubmit("asesoramos_banner", "Banner principal");
            Swal.fire({
              icon: "success",
              title: "Perfecto!",
              text: "Nos contactaremos contigo muy pronto!",
            });
          });
        })
        .catch((error) => {
          // Imprime el mensaje de error en la consola
          console.error(error.message);
          // Muestra el mensaje de error en la validación de Swal
          Swal.showValidationMessage(`Hay errores en el formulario, ${error.message}`);
        });
      },
    });
  }, []);

  return (
    <>
      <Carousel fade={true} pause={false}>
        {Imgs.map((Img) => {
          return (
            <Carousel.Item interval={5000}>
              <img
                className="responsive d-block "
                src={Img.banner}
                alt="First slide"
                id={Img.id}
                role="button"
                style={{ cursor: "pointer" }}
                onClick={() => (window.location.href = "/Register")}
              />
              <Carousel.Caption>
              <div className="flex justify-center items-center mb-2">
                <button
                  className="flex justify-center items-center w-14 rounded-full  lg:w-60  bg-colorprimary lg:rounded-lg text-colorprimary-50 gap-1 hover:bg-colorsixth hover:text-colorprimary  ..."
                  onClick={() => { trackBannerClick("Convenio universidades"); window.location.href = "/RegisterCampaign"; }}>
                  <Cart
                  className="inline-flex justify-center items-center"
                  />
                   <b className="hidden lg:flex">Convenio universidades</b>
                </button>
              </div>
                <div className="flex justify-center items-center">
                  <button
        
                  href="/planes"
                  className="flex justify-center items-center w-14 rounded-full  lg:w-60 bg-colorsixth lg:rounded-lg text-colorprimary gap-2 hover:text-white hover:bg-colorprimary shadow-lg ..."
                  onClick={() => { trackBannerClick("Te asesoramos"); handleButtonClick(); }}
                >
                  <Phone className="inline-flex justify-center items-center"
                  />
                  <b className="hidden lg:flex">Te asesoramos </b>
                  </button>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </>
  );
};

export default React.memo(Carouselcomp);

// ## Summary
// This code defines a React component called `Carouselcomp` that displays a carousel of images fetched from a server. It also includes a button that opens a modal for the user to fill out a form and submit it.

// ## Example Usage
// ```javascript
// import React from "react";
// import Carouselcomp from "./Carouselcomp";

// const App = () => {
//   return (
//     <div>
//       <h1>Carousel Component</h1>
//       <Carouselcomp />
//     </div>
//   );
// };

// export default App;
// ```

// ## Code Analysis
// ### Inputs
// - None
// ___
// ### Flow
// 1. The component initializes two state variables, `data` and `Imgs`, using the `useState` hook.
// 2. The `getData` function is defined as a callback function using the `useCallback` hook. It fetches data from the server using the `fetch` API and updates the `data` and `Imgs` state variables.
// 3. The `getData` function is called once when the component mounts using the `useEffect` hook.
// 4. The `handleButtonClick` function is defined as a callback function using the `useCallback` hook. It opens a modal using the `Swal.fire` function from the SweetAlert library and allows the user to fill out a form.
// 5. When the form is submitted, the `preConfirm` callback is triggered. It sends a POST request to the server with the form data and shows a success message if the request is successful.
// 6. The component renders a `Carousel` component from the `react-bootstrap` library, with each image from the `Imgs` state variable as a slide.
// 7. Each slide includes a button that triggers the `handleButtonClick` function when clicked.
// ___
// ### Outputs
// - The component renders a carousel of images fetched from the server.
// - The component includes a button that opens a modal for the user to fill out a form and submit it.
// ___
